import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddEditMotOnStorageDocumentSaveModel } from 'app/tos-operations/models/AddEditMotOnStorageDocument.save.model';
import { RemoveMotFromStorageDocumentSaveModel } from 'app/tos-operations/models/RemoveMotFromStorageDocument.save.model';
import { StorageDocumentCreateResultModel } from 'app/tos-operations/models/StorageDocumentCreateResult.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StorageDocumentService {
    constructor(private http: HttpClient) {}

    getStorageDocumentsList(filter: any): Observable<any> {
        return this.http.post('api:///StorageDocument/GetStorageDocumentsList', filter);
    }

    getStorageDocument(id: number): Observable<any> {
        return this.http.get(`api:///StorageDocument/GetStorageDocument/${id}`);
    }

    getStorageDocumentFromSRVersionShipment(id: number): Observable<any> {
        return this.http.get(`api:///StorageDocument/GetStorageDocumentFromSRVersionShipment/${id}`);
    }

    createStorageDocument(data: any): Observable<StorageDocumentCreateResultModel> {
        return this.http.post<StorageDocumentCreateResultModel>(`api:///StorageDocument/CreateStorageDocument`, data);
    }

    submitStorageDocument(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/SubmitStorageDocument`, data);
    }

    cancelStorageDocument(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/CancelStorageDocument`, data);
    }

    removeStorageDocumentItems(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/RemoveStorageDocumentItems`, data);
    }

    saveStorageDocumentItem(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/SaveStorageDocumentItem`, data);
    }

    updateStorageDocumentItemStatus(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/UpdateStorageDocumentItemStatus`, data);
    }

    saveStorageDocumentItemScaleWeights(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/SaveStorageDocumentItemScaleWeights`, data);
    }

    assignWarehouse(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/AssignWarehouseForStorageDocumentItems`, data);
    }

    saveStorageDocumentRemark(data: any): Observable<any> {
        return this.http.post(`api:///StorageDocument/SaveStorageDocumentRemark`, data);
    }

    addAttachment(model: any) {
        return this.http.post<any>(`api:///StorageDocument/AddAttachment`, model);
    }

    removeAttachment(model: any) {
        return this.http.post<any>(`api:///StorageDocument/RemoveAttachment`, model);
    }

    deleteStorageDocument(storageDocumentId: number): Observable<any> {
        return this.http.post(`api:///StorageDocument/DeleteStorageDocument/${storageDocumentId}`, null);
    }

    getStorageDocumentMOTsForDropDown(storageDocumentId: number): Observable<any> {
        return this.http.get(`api:///StorageDocument/GetStorageDocumentMOTsForDropDown/${storageDocumentId}`);
    }

    addMotOnStorageDocument(body: AddEditMotOnStorageDocumentSaveModel): Observable<any> {
        return this.http.post<any>(`api:///StorageDocument/AddMotOnStorageDocument/`, body);
    }

    editMotOnStorageDocument(body: AddEditMotOnStorageDocumentSaveModel): Observable<any> {
        return this.http.post<any>(`api:///StorageDocument/EditMotOnStorageDocument/`, body);
    }

    removeMotFromStorageDocument(body: RemoveMotFromStorageDocumentSaveModel): Observable<any> {
        return this.http.post<any>(`api:///StorageDocument/RemoveMotFromStorageDocument/`, body);
    }

    downloadExcelTemplate() {
        return this.http.get<any>(`api:///StorageDocument/DownloadExcelTemplate`);
    }

    downloadStorageDocumentItemsExcel(model: any): Observable<any> {
        return this.http.post<any>(`api:///StorageDocument/DownloadStorageDocumentItemsExcel`, model);
    }

    uploadExcel(model: any): Observable<any> {
        return this.http.post<any>(`api:///StorageDocument/UploadExcelOnStorageDocument`, model);
    }

    getPrintData(id: number): Observable<any> {
        return this.http.get(`api:///StorageDocument/GetStorageDocumentPrintData/${id}`);
    }

    getDocumentsForServiceRequest(filter: any): Observable<any> {
        return this.http.post('api:///StorageDocument/GetDocumentsForServiceRequest', filter);
    }

    getItemWarehouses(filter: any): Observable<any> {
        return this.http.post('api:///StorageDocument/GetItemWarehouses', filter);
    }

    getWarehousesForAsign(filter: any): Observable<any> {
        return this.http.post('api:///StorageDocument/GetWarehousesForAsign', filter);
    }
}
